const Theme = window.Theme || {};

Theme.URLParams = {
  has: function (key) {
    const url = new URL(window.location.href);
    return url.searchParams.has(key);
  }
};

class CartLink extends HTMLElement {
  constructor() {
    super();

    const elements = {
      count: this.querySelector(".cart-count-bubble")
    };

    this.addEventListener("click", (event) => {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent("cartlink:click"));
    });

    document.addEventListener("cartitemquantity:change", (event) => {
      const cart_products = event.detail.cart.items.filter((item) => {
        return item.vendor == "HoldOn";
      });

      const count = cart_products
        .map(item => item.quantity)
        .reduce((a, b) => a + b, 0);

      if (count == 0) {
        elements.count.classList.add("hidden");
      }

      elements.count.textContent = count;
    });

    document.addEventListener("productform:addtocart", (event) => {
      console.log(event.detail.variant);
      elements.count.textContent = Number(elements.count.textContent) + event.detail.variant.quantity;
      elements.count.classList.remove("hidden");
    });
  }
}

customElements.define("cart-link", CartLink);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("productform:addtocart", (event) => {
      this.render().then(() => this.show());
    });

    document.addEventListener("cartlink:click", (event) => {
      this.show();
    });

    if (Theme.URLParams.has("cart")) {
      this.show();
    }
  }

  show() {
    setTimeout(() => {
      this.classList.add("state--active");
    }, 50);
  }

  hide() {
    this.classList.remove("state--active");
  }

  async change(data) {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(data)
    });

    return await response.json();
  }

  render() {
    const current_content = document.getElementById("cart-content");

    function get_new_content(response) {
      const string = JSON.parse(response)["cart-drawer"];
      const parser = new DOMParser();
      const doc = parser.parseFromString(string, "text/html");

      return doc.getElementById("cart-content");
    }

    return fetch("/?sections=cart-drawer")
      .then((response) => response.text())
      .then((response) => {
        current_content.replaceWith(get_new_content(response));
      });
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartOverlay extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-drawer").hide();
    });
  }
}

customElements.define("cart-overlay", CartOverlay);


class CartClose extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-drawer").hide();
    });
  }
}

customElements.define("cart-close", CartClose);

class CartItemQuantity extends HTMLElement {
  constructor() {
    super();

    const CartDrawer = this.closest("cart-drawer");

    const key = this.getAttribute("key");

    const quantity = Number(this.getAttribute("quantity"));

    let data = {
      id: key,
      quantity: quantity
    };

    this.addEventListener("click", (event) => {
      if (event.target.nodeName == "BUTTON") {
        document.dispatchEvent(new CustomEvent("cartitemquantity:click", {
          detail: {
            key: key
          }
        }));

        data.quantity += Number(event.target.dataset.increment);

        CartDrawer.change(data)
          .then((cart) => {
            document.dispatchEvent(new CustomEvent("cartitemquantity:change", {
              detail: {
                cart: cart
              }
            }));

            const cart_products = cart.items.filter((item) => {
              return item.vendor == "HoldOn";
            });

            if (cart_products.length == 0) {
              CartDrawer.hide();
            }
          })
          .then(() => CartDrawer.render())
      }
    });
  }
}

customElements.define("cart-item-quantity", CartItemQuantity);

class CartItemRemove extends HTMLElement {
  constructor() {
    super();

    const CartDrawer = this.closest("cart-drawer");

    const key = this.getAttribute("key");

    const data = {
      id: key,
      quantity: 0
    };

    this.addEventListener("click", (event) => {
      event.preventDefault();

      document.dispatchEvent(new CustomEvent("cartitemremove:click", {
        detail: {
          key: key
        }
      }));

      CartDrawer.change(data)
        .then((cart) => {
          document.dispatchEvent(new CustomEvent("cartitemquantity:change", {
            detail: {
              cart: cart
            }
          }));

          const cart_products = cart.items.filter((item) => {
            return item.vendor == "HoldOn";
          });

          if (cart_products.length == 0) {
            CartDrawer.hide();
          }
        })
        .then(() => CartDrawer.render());
    });
  }
}

customElements.define("cart-item-remove", CartItemRemove);

class CartLoadingIndicator extends HTMLElement {
  constructor() {
    super();

    const key = this.getAttribute("key");

    document.addEventListener("cartitemremove:click", (event) => {
      if (key == event.detail.key) {
        this.show();
      }
    });

    document.addEventListener("cartitemquantity:click", (event) => {
      if (key == event.detail.key) {
        this.show();
      }
    });

    document.addEventListener("cartsubscription:change", (event) => {
      if (key == event.detail.key) {
        this.show();
      }
    });

    document.addEventListener("cartsubscriptionupsell:click", (event) => {
      console.log(key, event.detail.key);

      if (key == event.detail.key) {
        this.show();
      }
    });
  }

  show() {
    this.classList.remove("hidden");
  }
}

customElements.define("cart-loading-indicator", CartLoadingIndicator);

class CartSubscription extends HTMLElement {
  constructor() {
    super();

    const select = this.querySelector("select");

    select.addEventListener("change", (event) => {
      event.preventDefault();
      event.stopPropagation();

      document.dispatchEvent(new CustomEvent("cartsubscription:change", {
        detail: {
          key: this.dataset.key
        }
      }));

      const option = event.target[event.target.selectedIndex];
      const key = option.dataset.key;
      const variant_id = Number(option.dataset.variantId);
      const id = Number(option.dataset.id);

      const data = {
        "items": [
          {
            "id": variant_id,
            "quantity": 1,
            "selling_plan": id
          }
        ]
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      })
      .then((response) => response.json())
      .then((response) => {
        const CartItemRemove = this.closest(".cart-item").querySelector("cart-item-remove");

        CartItemRemove.click();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  }
}

customElements.define("cart-subscription", CartSubscription);

class CartSubscriptionUpsell extends HTMLElement {
  constructor() {
    super();

    const elements = {
      button: this.querySelector("button")
    };

    const key = this.getAttribute("key");

    const variant_id = this.getAttribute("variant-id");

    const selling_plan_id = this.getAttribute("selling-plan-id");

    const data = {
      "items": [
        {
          "id": variant_id,
          "quantity": 1,
          "selling_plan": selling_plan_id
        }
      ]
    };

    elements.button.addEventListener("click", (event) => {
      document.dispatchEvent(new CustomEvent("cartsubscriptionupsell:click", {
        detail: {
          key: key
        }
      }));

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      })
      .then((response) => response.json())
      .then((response) => {
        const CartItemRemove = this.closest(".cart-item").querySelector("cart-item-remove");

        CartItemRemove.click();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  }
}

customElements.define("cart-subscription-upsell", CartSubscriptionUpsell);

class CartShippedRemove extends HTMLElement {
  constructor() {
    super();

    const CartDrawer = this.closest("cart-drawer");

    const data = {};

    const shipped_keys = this.getAttribute("data-shipped-keys");

    shipped_keys.forEach(function (key) {
      data[key] = 0;
    });

    this.addEventListener("click", (event) => {
      event.preventDefault();

      this.classList.add("state--loading");

      CartDrawer.change(data)
        .then(() => CartDrawer.render());
    });
  }
}

customElements.define("cart-shipped-remove", CartShippedRemove);


